import * as tslib_1 from "tslib";
import { html, LitElement, customElement, property } from 'lit-element';
import { scroll } from './scroll.js';
/**
 * A LitElement wrapper of the scroll directive.
 *
 * Import this module to declare the lit-virtualizer custom element.
 * Pass an items array, renderItem method, and scroll target as properties
 * to the <lit-virtualizer> element.
 */
let LitVirtualizer = class LitVirtualizer extends LitElement {
    constructor() {
        super();
        this.renderRoot = this;
    }
    /**
     * The method used for rendering each item.
     */
    get renderItem() {
        return this._renderItem;
    }
    set renderItem(renderItem) {
        if (renderItem !== this.renderItem) {
            this._renderItem = renderItem;
            this.requestUpdate();
        }
    }
    /**
     * Scroll to the specified index, placing that item at the given position
     * in the scroll view.
     */
    async scrollToIndex(index, position = 'start') {
        this._scrollToIndex = { index, position };
        this.requestUpdate();
        await this.updateComplete;
        this._scrollToIndex = null;
    }
    render() {
        return html `${scroll({
            items: this.items,
            renderItem: this._renderItem,
            scrollTarget: this.scrollTarget,
            scrollToIndex: this._scrollToIndex,
            useShadowDOM: true
            // TODO: allow configuration of a layout.
        })}`;
    }
};
tslib_1.__decorate([
    property()
], LitVirtualizer.prototype, "_renderItem", void 0);
tslib_1.__decorate([
    property()
], LitVirtualizer.prototype, "items", void 0);
tslib_1.__decorate([
    property()
], LitVirtualizer.prototype, "scrollTarget", void 0);
LitVirtualizer = tslib_1.__decorate([
    customElement('lit-virtualizer')
], LitVirtualizer);
export { LitVirtualizer };
